import React, { useEffect, useState } from "react";
import { Parallax } from "react-parallax";
import axios from "axios";
import image2 from "../Assets/page_bg.jpg";
import Footer from "./Footer";
import Header from "./Header";
import { Link } from "react-router-dom";
import CrackersLoader from './CrackersLoader';
import Stats from "./Stats";
import side_image from "../Assets/cc-middle.jpg";
import Sticker from "./Sticker";
import { FaShoppingCart, FaCogs, FaMapMarkerAlt, FaPhoneAlt, FaHome, FaInfoCircle, FaEnvelope, FaUser, FaWhatsapp, FaStar, FaAward, FaShippingFast } from "react-icons/fa";
import MobileNavigation from "./MobileNavigation";
import SafetySection from "./sections/SafetySection";

function About() {
  const [aboutData, setAboutData] = useState(null);
  const [contactData, setContactData] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

  useEffect(() => {
    const fetchAboutData = async () => {
      try {
        const response = await axios.get(`${API_BASE_URL}content.php`);
        const { body } = response.data;
        setAboutData(body.about);
        setContactData(body.contact);
      } catch (error) {
        console.error("Error fetching the about data", error);
      } finally {
        setIsLoading(false);
      }
    };

    fetchAboutData();
  }, []);

  if (isLoading) {
    return <CrackersLoader />;
  }

  return (
    <div className="about-page-wrapper">
      <div className="main-homepage">
        <Header />

        {/* Parallax Header - Same structure as Contact page */}
        <Parallax
          bgImage={image2}
          strength={300}
          className="about-parallax-header"
        >
          <div className="mathi-contact-header"> {/* Use same class as contact page */}
            <h1 className="mathi-contact-title"> {/* Use same class as contact page */}
              About BK Crackers
            </h1>
            <nav className="mathi-contact-breadcrumb"> {/* Use same class as contact page */}
              <ol className="mathi-breadcrumb-list"> {/* Use same class as contact page */}
                <li className="mathi-breadcrumb-item"> {/* Use same class as contact page */}
                  <Link to="/" className="mathi-breadcrumb-link">Home</Link> {/* Use same class as contact page */}
                </li>
                <li className="mathi-breadcrumb-divider"> {/* Use same class as contact page */}
                  <i className="bi bi-chevron-right"></i>
                </li>
                <li className="mathi-breadcrumb-item active">About Us</li> {/* Use same class as contact page */}
              </ol>
            </nav>
          </div>
        </Parallax>

        {/* Rest of your About page content remains exactly the same */}
        <div className="container about-container">
          <div className="about-main-section">
            {/* Shop Details Header */}
            <div className="about-shop-header text-center">
              <span className="about-subtitle">OUR SHOP DETAILS</span>
              <h1 className="about-main-title">
                BK Crackers
              </h1>
              <h3 className="about-shop-tagline">
                WHOLESALE & RETAIL SHOP IN{" "}
                <span className="highlight-sivakasi">SIVAKASI</span>
              </h3>
              <div className="title-divider">
                <span className="divider-dot"></span>
                <span className="divider-dot"></span>
                <span className="divider-dot"></span>
              </div>
            </div>

            {/* About Description */}
            <div className="about-description-section mb-5">
              <div className="row">
                <div className="col-lg-12">
                  <div
                    className="about-description-text"
                    dangerouslySetInnerHTML={{ __html: aboutData?.value || '' }}
                  />
                </div>
              </div>
            </div>

            {/* Stats Section */}
            <div className="about-stats-section mb-5">
              <Stats />
            </div>

            {/* Sticker Section */}
            <div className="about-sticker-section mb-5">
              <Sticker />
            </div>

            {/* Features Section with Image */}
            <div className="about-features-section mb-5">
              <div className="row align-items-center g-4">
                <div className="col-lg-6 order-lg-1 order-2">
                  <div className="about-features-content">
                    <h2 className="features-main-title">
                      ONLINE CRACKERS SHOP{" "}
                      <span className="highlight-online">SIVAKASI</span>
                    </h2>

                    <p className="features-intro">
                      We are a famous online pattasu kadai in Sivakasi, with more varieties
                      of Sivakasi crackers on board and purchase through online crackers shopping
                    </p>

                    <div className="feature-card">
                      <div className="feature-card-inner">
                        <div className="feature-icon-wrapper">
                          <FaShoppingCart className="feature-icon" />
                        </div>
                        <div className="feature-content">
                          <h4 className="feature-title">FLAT 80% OFF</h4>
                          <p className="feature-description">
                            Online Order for Flat 80% off from a great selection of
                            Fireworks Products at My Crackers
                          </p>
                        </div>
                      </div>
                    </div>

                    <div className="feature-card">
                      <div className="feature-card-inner">
                        <div className="feature-icon-wrapper">
                          <FaCogs className="feature-icon" />
                        </div>
                        <div className="feature-content">
                          <h4 className="feature-title">BRANDED CRACKERS</h4>
                          <p className="feature-description">
                            Spread the Light of Joy and Happiness with Branded Fire Crackers.
                            Kindly contact us for more details.
                          </p>
                        </div>
                      </div>
                    </div>

                    <div className="feature-card">
                      <div className="feature-card-inner">
                        <div className="feature-icon-wrapper">
                          <FaShippingFast className="feature-icon" />
                        </div>
                        <div className="feature-content">
                          <h4 className="feature-title">TIMELY DELIVERY</h4>
                          <p className="feature-description">
                            Our commitment on quality & timely delivery have been earning
                            reputations from our Happy Customers
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="col-lg-6 order-lg-2 order-1">
                  <div className="about-feature-image">
                    <div className="image-frame">
                      <img
                        src={side_image}
                        alt="My Crackers Shop"
                        className="feature-img"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <SafetySection />

            {/* Call to Action */}
            <div className="about-cta-section text-center py-4 mb-4">
              <div className="cta-card">
                <div className="cta-content">
                  <div className="cta-icon-wrapper">
                    <FaPhoneAlt className="cta-icon" />
                  </div>
                  <h2 className="cta-title">
                    Call To Ask Any Enquiry
                  </h2>
                  <div className="cta-phone">
                    <FaWhatsapp className="whatsapp-icon" />
                    <span className="phone-number">
                      +{contactData?.whatsapp_number || 'Contact Us'}
                    </span>
                  </div>
                  <p className="cta-subtitle">
                    Get the best deals on crackers with our special offers
                  </p>
                  <Link to="/contact" className="cta-button">
                    <FaEnvelope className="me-2" />
                    Contact Now
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>

        <Footer />
      </div>
      <MobileNavigation />
    </div>
  );
}

export default About;